import { AnimatePresence, motion } from 'motion/react';
import { useFormContext } from 'react-hook-form';
import { useQuestionnaireContext } from '../../context/QuestionnaireContext';
import { isQuestion } from '../../schemas/questionnaire-schema';

export const ErrorDisplay = () => {
  const { state } = useQuestionnaireContext();
  const {
    formState: { errors },
  } = useFormContext();

  const { currentQuestionIndex, questions } = state;
  const question = questions[currentQuestionIndex];

  if (!question || !isQuestion(question)) {
    return null;
  }

  // Only show error for the current question
  const currentQuestionError = errors[question.slug];
  const errorMessage = currentQuestionError?.message as string | undefined;

  return (
    <AnimatePresence>
      (
      <motion.div
        initial={{ opacity: 0, x: -10 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -10 }}
        transition={{ duration: 0.2 }}
        className={`error-display ${errorMessage ? 'visible' : 'hidden'}`}
      >
        <span className="error-display-icon">⚠</span>
        <p className="error-display-text">{errorMessage}</p>
      </motion.div>
      )
    </AnimatePresence>
  );
};
